import { render, staticRenderFns } from "./pc-mine.vue?vue&type=template&id=c0f7a58a&scoped=true"
import script from "./pc-mine.vue?vue&type=script&lang=js"
export * from "./pc-mine.vue?vue&type=script&lang=js"
import style0 from "./pc-mine.vue?vue&type=style&index=0&id=c0f7a58a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f7a58a",
  null
  
)

export default component.exports